/** appsCat: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "world_clock": "World Clock",
  "world_clockDesc": "Several cities' times side by side.",
  "countdown": "Countdown",
  "countdownDesc": "Days, hours and minutes to an event (or since it).",
  "text": "Text",
  "textDesc": "An announcement: a headline and text.",
  "ticker": "Ticker",
  "tickerDesc": "Your own messages scrolling across the screen.",
  "menu_board": "Menu Board",
  "menu_boardDesc": "A menu or price list in sections and columns.",
  "qr_code": "QR Code",
  "qr_codeDesc": "A scannable code for a link, Wi-Fi, menu or offer.",
  "web_page": "Web Page",
  "web_pageDesc": "Any https website, reloaded on a schedule.",
  "youtube": "YouTube",
  "youtubeDesc": "A YouTube video or playlist.",
  "dashboard": "BI dashboard",
  "dashboardDesc": "A Power BI, Looker Studio, Tableau, Grafana or Metabase dashboard, full screen and refreshed.",
  "biLink": "Dashboard link",
  "biTool": "Tool",
  "bi_powerbi": "Power BI",
  "bi_looker": "Looker Studio",
  "bi_tableau": "Tableau Public",
  "bi_grafana": "Grafana",
  "bi_metabase": "Metabase",
  "bi_other": "Other (any web page)",
  "biHow_powerbi": "In the report: File › Embed report › Publish to web (public), then copy the link.",
  "biHow_looker": "In the report: Share › Manage access › anyone with the link can view, then copy the report link.",
  "biHow_tableau": "On Tableau Public, open the viz and copy its link (Share › Link).",
  "biHow_grafana": "Use a public dashboard (Share › Public dashboard) or a link that opens without signing in; it plays in kiosk mode.",
  "biHow_metabase": "Dashboard › Sharing › Public link, then copy it.",
  "biHow_other": "Any https page that opens without signing in.",
  "biPublicOnly": "Screens can't sign in: use a link that opens without a login (public, published or shared-by-link).",
  "biLimits": "Some tools refuse to be shown inside other pages: then the preview here stays blank, and so do browser and ChromeOS players, while Android and desktop players still show it. Dashboards need a modern web engine: Android 5 boxes that never updated Android System WebView can't show them.",
  "biCheck_blocked": "This site doesn't allow being shown inside other pages ({detail}), so it can't be previewed here. Android and desktop players still show it; browser and ChromeOS players can't.",
  "biCheck_login": "This link asks people to sign in, and screens can't sign in. Use a public, published or shared-by-link address.",
  "biCheck_not_found": "Nothing at this address (not found). Check the link.",
  "biCheck_error": "This address can't be reached: {detail}",
  "biRefresh": "Reload",
  "biSelf": "Never (it refreshes itself)",
  "biTheme": "Theme",
  "biDark": "Dark",
  "biLight": "Light",
  "biOpens": "Screens open:",
  "people": "People",
  "peopleDesc": "Employee of the month, your team, birthdays or a staff directory from a Data Feed (a Google Sheet of staff).",
  "pePickFeed": "Choose a Data Feed with your people",
  "peFeedHint": "Edit the feed (or its Google Sheet) and the screens follow. Photos are links (https) in a column.",
  "peNoFeeds": "No Data Feeds yet: make one from a Google Sheet with a row per person (name, photo link, role, birthday…).",
  "peTeam": "Our team",
  "peSpotlight": "Employee of the month",
  "peBirthdays": "Birthdays",
  "peDirectory": "Directory",
  "peName": "Names from",
  "pePhoto": "Photos from",
  "peRole": "Role from",
  "peDetail": "Department / location from",
  "peMessage": "Message from",
  "pePhone": "Phone / extension from",
  "peDate": "Birthdays from",
  "peNone": "None",
  "peRange": "Show birthdays",
  "peToday": "Today",
  "peWeek": "Next 7 days",
  "peMonth": "This month",
  "peBirthdaysTitle": "Happy birthday",
  "pePersonSeconds": "Seconds per person",
  "pePageSeconds": "Seconds per page",
  "peAccent": "Accent",
  "peLanguage": "Labels",
  "peNoBirthdays": "No birthdays in this period",
  "photos": "Photos",
  "photosDesc": "A slideshow, a photo wall or instant photos from a Data Feed's picture links (a Google Sheet, an RSS feed).",
  "photosPickFeed": "Choose a Data Feed with picture links",
  "photosNone": "No https picture links in this column",
  "phFeedHint": "New rows in the feed reach the screens by themselves. Players keep the photos for offline play.",
  "phNoFeeds": "No Data Feeds yet: make one from a Google Sheet or a CSV with a column of picture links (https).",
  "phStyle": "Style",
  "phSlideshow": "Slideshow",
  "phWall": "Photo wall",
  "phPolaroid": "Instant photo",
  "phImages": "Pictures from",
  "phCaptions": "Captions from",
  "phNoCaption": "No caption",
  "phSeconds": "Seconds per photo",
  "phTileSeconds": "Change a tile every (s)",
  "phMax": "Photos at most",
  "phCols": "Columns",
  "phRows": "Rows",
  "phFit": "Photo",
  "phCover": "Fill",
  "phContain": "Whole photo",
  "phShuffle": "Shuffle the order",
  "chart": "Chart",
  "chartDesc": "Columns, bars, a line, a donut or a big number from a Data Feed (Google Sheets, CSV, JSON).",
  "chartPickFeed": "Choose a Data Feed to see the chart",
  "chartNoFeed": "This Data Feed can't be read",
  "chartNoTable": "This Data Feed has no data yet",
  "chFeed": "Data Feed",
  "chPickFeed": "Choose a Data Feed",
  "chFeedHint": "The chart updates by itself when the feed's data changes.",
  "chNoFeeds": "No Data Feeds yet: make one from a Google Sheet, a CSV or JSON link, or type a table.",
  "chOpenFeeds": "Data Feeds",
  "chKind": "Chart",
  "chColumn": "Columns",
  "chBar": "Bars",
  "chLine": "Line",
  "chPie": "Donut",
  "chNumber": "Number",
  "chLabels": "Labels from",
  "chValues": "Values from (up to 4)",
  "chValue": "Value from",
  "chSort": "Order",
  "chSortNone": "As in the feed",
  "chSortDesc": "Largest first",
  "chSortAsc": "Smallest first",
  "chRows": "Rows at most",
  "chPrefix": "Before values",
  "chSuffix": "After values",
  "chDecimals": "Decimals",
  "chShowValues": "Show the values on the chart",
  "chColors": "Colours",
  "chColorN": "Colour {n}",
  "chDirection": "Direction",
  "chLtr": "Left to right",
  "chRtl": "Right to left",
  "calendar": "Calendar",
  "calendarDesc": "Upcoming events from a Google, Outlook or Apple calendar.",
  "fIcalLink": "Calendar link (iCal)",
  "fIcalWhere": "Where do I find it?",
  "fIcalGoogle": "Google Calendar: Settings › your calendar › “Secret address in iCal format” (or the public address if it’s public).",
  "fIcalOutlook": "Outlook: Settings › Calendar › Shared calendars › Publish a calendar › copy the ICS link.",
  "fIcalApple": "Apple Calendar: share the calendar as Public Calendar and copy its webcal:// link.",
  "fCalTitlePh": "The calendar’s own name",
  "fDaysAhead": "Show",
  "fTodayOnly": "Today only",
  "fNDays": "Next {n} days",
  "fMaxEvents": "Events at most",
  "fShowWhere": "Show where each event is",
  "fCalRefresh": "Check for changes",
  "fCalAccent": "Day headings colour",
  "calNone": "No upcoming events",
  "calLoading": "Reading the calendar…",
  "calPasteLink": "Paste a calendar link to see its events",
  "calToday": "Today",
  "calTomorrow": "Tomorrow",
  "calAllDay": "All day",
  "calNow": "Now",
  "google_slides": "Google Slides",
  "google_slidesDesc": "A Google Slides presentation that advances by itself.",
  "cat_info": "Time & information",
  "cat_messages": "Messages",
  "cat_business": "Business",
  "cat_web": "Web & video",
  "fAbove": "Above",
  "fAccent": "Price colour",
  "fAddCity": "Add a city",
  "fAddItem": "Add an item",
  "fAddSection": "Add a section",
  "fAlign": "Alignment",
  "fBelow": "Below",
  "fBody": "Text",
  "fCaption": "Caption",
  "fCaptionPh": "e.g. Scan for the menu",
  "fCaptionPos": "Caption position",
  "fCaptions": "Show captions",
  "fCdTitlePh": "e.g. Grand opening in",
  "fCenter": "Centre",
  "fCities": "Cities",
  "fCity": "City",
  "fCityPh": "Name shown",
  "fColumns": "Columns",
  "fCount": "Count",
  "fCountDown": "Down to it",
  "fCountUp": "Up since it",
  "fDesc": "Description",
  "fDescPh": "Description (optional)",
  "fDoneText": "When it's time, show",
  "fDoneTextPh": "e.g. We're open!",
  "fEnd": "End",
  "fEveryHour": "Every hour | Every {n} hours",
  "fEveryMin": "Every {n} minutes",
  "fFoundPlaylist": "Playlist found.",
  "fFoundVideo": "Video found.",
  "fHeadline": "Headline",
  "fInteractive": "Allow touch (interactive kiosk)",
  "fItem": "Item",
  "fItemPh": "Item",
  "fLoop": "Loop",
  "fMenuTitlePh": "e.g. Today's menu",
  "fMessages": "Messages",
  "fMessagesHint": "One message per line.",
  "fMessagesPh": "Welcome to our store\nFree Wi-Fi: Guest",
  "fMuted": "Muted",
  "fNever": "Never",
  "fPrice": "Price",
  "fPricePh": "Price",
  "fQrData": "Link or text",
  "fRefresh": "Reload the page",
  "fRemove": "Remove",
  "fSection": "Section",
  "fSectionPh": "Section name (e.g. Hot drinks)",
  "fSeparator": "Between messages",
  "fShowDate": "Show the date",
  "fSlideSeconds": "Seconds per slide",
  "fSlidesHint": "In Google Slides choose File → Share → Publish to web, or set the link to \"Anyone with the link\".",
  "fSlidesLink": "Google Slides link",
  "fStart": "Start",
  "fTarget": "Date and time",
  "fTitle": "Title",
  "fUrl": "Website address",
  "fUrlHint": "Some websites don't allow being shown inside another app; those stay blank. Players need internet for this app.",
  "fXLarge": "Extra large",
  "fYouTubeHint": "Players need internet. Most players only play sound on a muted-off video if their volume is up.",
  "fYouTubeLink": "YouTube link",
  "fZoom": "Zoom",
  "time": "Time",
  "timeDesc": "Round or digital clock with date, in Arabic or English.",
  "prayer_time": "Prayer Time",
  "prayer_timeDesc": "Daily prayer times, calculated on the player.",
  "weather": "Weather",
  "weatherDesc": "Current conditions and forecast for a location.",
  "rss": "RSS Feeds",
  "rssDesc": "Scrolling headlines from any https RSS or Atom feed.",
  "fHex": "{what} hex",
  "pvAt": "Previewing at {place}, times in {zone} (each player uses its own time zone).",
  "method_GULF": "Gulf region",
  "method_MAKKAH": "Umm al-Qura, Makkah",
  "method_MWL": "Muslim World League",
  "method_EGYPT": "Egyptian General Authority",
  "method_KARACHI": "University of Islamic Sciences, Karachi",
  "method_ISNA": "ISNA (North America)",
  "method_SINGAPORE": "Singapore",
  "method_TEHRAN": "Institute of Geophysics, Tehran",
  "method_JAFARI": "Shia Ithna Ashari (Jafari)",
  "fArabic": "Arabic",
  "fEnglish": "English",
  "fUrdu": "Urdu",
  "fAppLanguage": "App language",
  "fTimeFormat": "Time format",
  "f24": "24 Hours",
  "fAmPm": "AM/PM",
  "fTimezone": "Timezone",
  "fPlayerLocation": "Player Location",
  "fCustom": "Custom",
  "fCustomTz": "Custom timezone",
  "fClockType": "Clock type",
  "fRound": "Clock Round",
  "fDigital": "Clock Digital",
  "fMore": "Additional options",
  "fHideCity": "Hide city/country",
  "fHideDate": "Hide date",
  "fShowSeconds": "Show seconds",
  "fHideSeconds": "Hide seconds",
  "fHideTime": "Hide the time under the clock",
  "fHideSecondsHand": "Hide seconds (and the seconds hand)",
  "fMethod": "Calculation method",
  "fAsr": "Asr",
  "fStandard": "Standard (Shafi, Maliki, Hanbali)",
  "fHanafi": "Hanafi",
  "fHighlight": "Highlight the next prayer",
  "fTemperature": "Temperature",
  "fCelsius": "Celsius",
  "fFahrenheit": "Fahrenheit",
  "fForecast": "Forecast days",
  "fNone": "None",
  "fLocation": "Location",
  "fOwnCoords": "Each player uses its own coordinates (set in Players → Edit).",
  "fLatPh": "Latitude, e.g. 25.2048",
  "fLat": "Latitude",
  "fLngPh": "Longitude, e.g. 55.2708",
  "fLng": "Longitude",
  "fRssUrl": "RSS URL",
  "fFontSize": "App font size",
  "fSmall": "Small",
  "fMedium": "Medium",
  "fLarge": "Large",
  "fSpeed": "Speed",
  "fSlow": "Slow",
  "fFast": "Fast",
  "fDirection": "Text direction",
  "fLtr": "Left To Right",
  "fRtl": "Right To Left",
  "fHeadlines": "Headlines",
  "fBg": "Background color",
  "fFg": "Font color",
  "pvOf": "Preview of the app",
  "pvEnterFeed": "Enter an https feed URL to preview its headlines.",
  "pvApprox": "Approximate preview; the player renders this app natively.",
  "pvLoading": "Loading headlines…",
  /* Meeting room */
  "meeting_room": "Meeting room",
  "meeting_roomDesc": "A room-door screen: free or busy now, the current meeting, the next one and the rest of today, from the room's calendar link.",
  "mrIcalLink": "Room calendar link (iCal)",
  "mrRoomName": "Room name",
  "mrRoomNamePh": "Blank: the calendar's own name",
  "mrHideTitles": "Hide meeting titles (show \"Busy\" only)",
  "mrShowOrganizer": "Show the organiser",
  "mrMaxUpcoming": "Later meetings to list",
  "mrLayout": "Layout",
  "mrAuto": "Auto",
  "mrLandscape": "Landscape",
  "mrPortrait": "Portrait",
  "mrFreeColor": "Free colour",
  "mrBusyColor": "Busy colour",
  "mrNoMeeting": "No meeting on now",
  "stream": "Streaming video",
  "streamDesc": "A live stream (HLS .m3u8 or MPEG-DASH .mpd) or a video file played from its link.",
  "stLink": "Stream link (https)",
  "stCheck": "Check link",
  "stChecking": "Checking…",
  "stBadLink": "Enter a full https:// link to the stream (for example https://example.com/live/index.m3u8).",
  "stOk": "The link answers: {kind}. The preview plays it.",
  "stKind_hls": "an HLS stream",
  "stKind_dash": "an MPEG-DASH stream",
  "stKind_file": "a video file",
  "stKind_unknown": "a stream",
  "stVerdict_ok": "The link answers.",
  "stVerdict_not_stream": "This link opens a web page or other content, not a video stream. Use the stream's own .m3u8 or .mpd link.",
  "stVerdict_login": "The stream needs signing in; screens can't sign in. Use a public link.",
  "stVerdict_not_found": "Nothing at this link (not found). The stream may have ended or moved.",
  "stVerdict_error": "The stream couldn't be reached right now.",
  "stEnterLink": "Enter a stream link to preview it.",
  "stSupported": "Supported: HLS (.m3u8), MPEG-DASH (.mpd) and video files (.mp4, .webm) over https. Not supported: RTSP, RTMP, YouTube or other web pages (use the YouTube or web page apps), DRM-protected streams.",
  "stOnline": "Live streams need the internet: offline screens show the poster / text below and reconnect by themselves when the network is back.",
  "stFit": "Fit",
  "stContain": "Whole picture",
  "stCover": "Fill the zone",
  "stMuted": "Muted",
  "stPoster": "Poster picture link (optional)",
  "stFallback": "Text while connecting or when the stream is down (optional)",
  "stFallbackHint": "Shown on the background colour, with the poster if there is one.",
  // Social wall app
  "social_wall": "Social wall",
  "social_wallDesc": "Social posts as cards (author, picture, time, platform) from a Data Feed: a Google Sheet or an RSS/Atom feed such as a Mastodon account.",
  "swPickFeed": "Choose a Data Feed with your posts",
  "swFeedHint": "A row per post. RSS and Atom feeds (Mastodon accounts, RSS bridges) work as they are; pictures are https links.",
  "swNoFeeds": "No Data Feeds yet: make one from a Google Sheet (author, handle, avatar, text, image, date, platform) or an RSS feed.",
  "swWall": "Wall",
  "swSpotlight": "One post at a time",
  "swStrip": "Scrolling strip",
  "swText": "Post text from",
  "swAuthor": "Author from",
  "swHandle": "Handle from",
  "swAvatar": "Avatar from",
  "swImage": "Picture from",
  "swDate": "Date from",
  "swPlatform": "Platform from",
  "swMax": "Posts at most",
  "swPageSeconds": "Seconds per page",
  "swPostSeconds": "Seconds per post",
  "swCardSeconds": "Seconds per card",
  "swImagesOnly": "Only posts with a picture",
  "swShowPlatform": "Show the platform badge",
  "swNoPosts": "No posts in this feed yet",
};
const ar: typeof en = {
  "world_clock": "الساعة العالمية",
  "world_clockDesc": "أوقات عدة مدن جنبًا إلى جنب.",
  "countdown": "العد التنازلي",
  "countdownDesc": "الأيام والساعات والدقائق حتى حدث (أو منذ وقوعه).",
  "text": "نص",
  "textDesc": "إعلان: عنوان ونص.",
  "ticker": "شريط متحرك",
  "tickerDesc": "رسائلك تتحرك عبر الشاشة.",
  "menu_board": "لوحة القائمة",
  "menu_boardDesc": "قائمة طعام أو أسعار في أقسام وأعمدة.",
  "qr_code": "رمز QR",
  "qr_codeDesc": "رمز قابل للمسح لرابط أو شبكة واي فاي أو قائمة أو عرض.",
  "web_page": "صفحة ويب",
  "web_pageDesc": "أي موقع https، يُعاد تحميله حسب جدول.",
  "youtube": "يوتيوب",
  "youtubeDesc": "فيديو أو قائمة تشغيل من يوتيوب.",
  "dashboard": "لوحة BI",
  "dashboardDesc": "لوحة Power BI أو Looker Studio أو Tableau أو Grafana أو Metabase بملء الشاشة مع تحديث.",
  "biLink": "رابط اللوحة",
  "biTool": "الأداة",
  "bi_powerbi": "Power BI",
  "bi_looker": "Looker Studio",
  "bi_tableau": "Tableau Public",
  "bi_grafana": "Grafana",
  "bi_metabase": "Metabase",
  "bi_other": "أخرى (أي صفحة ويب)",
  "biHow_powerbi": "في التقرير: ملف › تضمين التقرير › النشر على الويب (عام)، ثم انسخ الرابط.",
  "biHow_looker": "في التقرير: مشاركة › إدارة الوصول › أي شخص لديه الرابط يمكنه العرض، ثم انسخ رابط التقرير.",
  "biHow_tableau": "على Tableau Public افتح العرض وانسخ رابطه (مشاركة › رابط).",
  "biHow_grafana": "استخدم لوحة عامة (مشاركة › لوحة عامة) أو رابطًا يفتح دون تسجيل دخول؛ تُعرض في وضع الكشك.",
  "biHow_metabase": "اللوحة › المشاركة › رابط عام، ثم انسخه.",
  "biHow_other": "أي صفحة https تفتح دون تسجيل دخول.",
  "biPublicOnly": "لا تستطيع الشاشات تسجيل الدخول: استخدم رابطًا يفتح دون تسجيل (عام أو منشور أو مشارك برابط).",
  "biLimits": "بعض الأدوات ترفض العرض داخل صفحات أخرى: عندها تبقى المعاينة هنا فارغة وكذلك مشغلات المتصفح وChromeOS، بينما تعرضها مشغلات Android وسطح المكتب. تحتاج اللوحات محرك ويب حديثًا: أجهزة Android 5 التي لم تُحدِّث Android System WebView لا تستطيع عرضها.",
  "biCheck_blocked": "هذا الموقع لا يسمح بعرضه داخل صفحات أخرى ({detail})، لذلك لا يمكن معاينته هنا. مشغلات Android وسطح المكتب تعرضه، ومشغلات المتصفح وChromeOS لا تستطيع.",
  "biCheck_login": "هذا الرابط يطلب تسجيل الدخول، والشاشات لا تستطيع ذلك. استخدم رابطًا عامًا أو منشورًا أو مشاركًا برابط.",
  "biCheck_not_found": "لا يوجد شيء على هذا العنوان (غير موجود). تحقق من الرابط.",
  "biCheck_error": "لا يمكن الوصول إلى هذا العنوان: {detail}",
  "biRefresh": "إعادة التحميل",
  "biSelf": "أبدًا (تتحدث تلقائيًا)",
  "biTheme": "المظهر",
  "biDark": "داكن",
  "biLight": "فاتح",
  "biOpens": "تفتح الشاشات:",
  "people": "الأشخاص",
  "peopleDesc": "موظف الشهر أو فريقك أو أعياد الميلاد أو دليل الموظفين من مصدر بيانات (Google Sheet للموظفين).",
  "pePickFeed": "اختر مصدر بيانات فيه الأشخاص",
  "peFeedHint": "عدّل المصدر (أو ملف Google Sheet) فتتبعه الشاشات. الصور روابط (https) في عمود.",
  "peNoFeeds": "لا توجد مصادر بيانات بعد: أنشئ واحدًا من Google Sheet بصف لكل شخص (الاسم، رابط الصورة، المسمى، تاريخ الميلاد…).",
  "peTeam": "فريقنا",
  "peSpotlight": "موظف الشهر",
  "peBirthdays": "أعياد الميلاد",
  "peDirectory": "الدليل",
  "peName": "الأسماء من",
  "pePhoto": "الصور من",
  "peRole": "المسمى من",
  "peDetail": "القسم / الموقع من",
  "peMessage": "الرسالة من",
  "pePhone": "الهاتف / التحويلة من",
  "peDate": "تواريخ الميلاد من",
  "peNone": "لا شيء",
  "peRange": "عرض أعياد الميلاد",
  "peToday": "اليوم",
  "peWeek": "الأيام السبعة القادمة",
  "peMonth": "هذا الشهر",
  "peBirthdaysTitle": "عيد ميلاد سعيد",
  "pePersonSeconds": "ثوانٍ لكل شخص",
  "pePageSeconds": "ثوانٍ لكل صفحة",
  "peAccent": "لون التمييز",
  "peLanguage": "لغة العناوين",
  "peNoBirthdays": "لا توجد أعياد ميلاد في هذه الفترة",
  "photos": "الصور",
  "photosDesc": "عرض شرائح أو جدار صور أو صور فورية من روابط الصور في مصدر بيانات (Google Sheet أو RSS).",
  "photosPickFeed": "اختر مصدر بيانات فيه روابط صور",
  "photosNone": "لا توجد روابط صور https في هذا العمود",
  "phFeedHint": "الصفوف الجديدة في المصدر تصل إلى الشاشات تلقائيًا. تحتفظ المشغلات بالصور للعرض دون اتصال.",
  "phNoFeeds": "لا توجد مصادر بيانات بعد: أنشئ واحدًا من Google Sheet أو CSV فيه عمود روابط صور (https).",
  "phStyle": "النمط",
  "phSlideshow": "عرض شرائح",
  "phWall": "جدار صور",
  "phPolaroid": "صورة فورية",
  "phImages": "الصور من",
  "phCaptions": "التعليقات من",
  "phNoCaption": "بدون تعليق",
  "phSeconds": "ثوانٍ لكل صورة",
  "phTileSeconds": "تغيير مربع كل (ثانية)",
  "phMax": "أقصى عدد للصور",
  "phCols": "الأعمدة",
  "phRows": "الصفوف",
  "phFit": "الصورة",
  "phCover": "ملء",
  "phContain": "الصورة كاملة",
  "phShuffle": "ترتيب عشوائي",
  "chart": "مخطط",
  "chartDesc": "أعمدة أو أشرطة أو خط أو حلقة أو رقم كبير من مصدر بيانات (Google Sheets أو CSV أو JSON).",
  "chartPickFeed": "اختر مصدر بيانات لرؤية المخطط",
  "chartNoFeed": "تعذّرت قراءة مصدر البيانات هذا",
  "chartNoTable": "لا توجد بيانات في هذا المصدر بعد",
  "chFeed": "مصدر البيانات",
  "chPickFeed": "اختر مصدر بيانات",
  "chFeedHint": "يتحدث المخطط تلقائيًا عند تغيّر بيانات المصدر.",
  "chNoFeeds": "لا توجد مصادر بيانات بعد: أنشئ واحدًا من Google Sheet أو رابط CSV أو JSON أو اكتب جدولًا.",
  "chOpenFeeds": "مصادر البيانات",
  "chKind": "المخطط",
  "chColumn": "أعمدة",
  "chBar": "أشرطة",
  "chLine": "خط",
  "chPie": "حلقة",
  "chNumber": "رقم",
  "chLabels": "التسميات من",
  "chValues": "القيم من (حتى 4)",
  "chValue": "القيمة من",
  "chSort": "الترتيب",
  "chSortNone": "كما في المصدر",
  "chSortDesc": "الأكبر أولًا",
  "chSortAsc": "الأصغر أولًا",
  "chRows": "أقصى عدد للصفوف",
  "chPrefix": "قبل القيم",
  "chSuffix": "بعد القيم",
  "chDecimals": "المنازل العشرية",
  "chShowValues": "عرض القيم على المخطط",
  "chColors": "الألوان",
  "chColorN": "اللون {n}",
  "chDirection": "الاتجاه",
  "chLtr": "من اليسار إلى اليمين",
  "chRtl": "من اليمين إلى اليسار",
  "calendar": "التقويم",
  "calendarDesc": "الأحداث القادمة من تقويم Google أو Outlook أو Apple.",
  "fIcalLink": "رابط التقويم (iCal)",
  "fIcalWhere": "أين أجده؟",
  "fIcalGoogle": "تقويم Google: الإعدادات › تقويمك › «العنوان السري بتنسيق iCal» (أو العنوان العام إن كان عامًا).",
  "fIcalOutlook": "Outlook: الإعدادات › التقويم › التقويمات المشتركة › نشر تقويم › انسخ رابط ICS.",
  "fIcalApple": "تقويم Apple: شارك التقويم كتقويم عام وانسخ رابط webcal://.",
  "fCalTitlePh": "اسم التقويم نفسه",
  "fDaysAhead": "عرض",
  "fTodayOnly": "اليوم فقط",
  "fNDays": "الأيام الـ {n} القادمة",
  "fMaxEvents": "أقصى عدد للأحداث",
  "fShowWhere": "عرض مكان كل حدث",
  "fCalRefresh": "التحقق من التغييرات",
  "fCalAccent": "لون عناوين الأيام",
  "calNone": "لا توجد أحداث قادمة",
  "calLoading": "جارٍ قراءة التقويم…",
  "calPasteLink": "الصق رابط تقويم لرؤية أحداثه",
  "calToday": "اليوم",
  "calTomorrow": "غدًا",
  "calAllDay": "طوال اليوم",
  "calNow": "الآن",
  "google_slides": "عروض Google",
  "google_slidesDesc": "عرض تقديمي من Google Slides يتقدم تلقائيًا.",
  "cat_info": "الوقت والمعلومات",
  "cat_messages": "الرسائل",
  "cat_business": "الأعمال",
  "cat_web": "الويب والفيديو",
  "fAbove": "أعلى",
  "fAccent": "لون السعر",
  "fAddCity": "إضافة مدينة",
  "fAddItem": "إضافة عنصر",
  "fAddSection": "إضافة قسم",
  "fAlign": "المحاذاة",
  "fBelow": "أسفل",
  "fBody": "النص",
  "fCaption": "التعليق",
  "fCaptionPh": "مثال: امسح لعرض القائمة",
  "fCaptionPos": "موضع التعليق",
  "fCaptions": "عرض الترجمة",
  "fCdTitlePh": "مثال: الافتتاح الكبير خلال",
  "fCenter": "الوسط",
  "fCities": "المدن",
  "fCity": "المدينة",
  "fCityPh": "الاسم المعروض",
  "fColumns": "الأعمدة",
  "fCount": "العد",
  "fCountDown": "تنازلي حتى الموعد",
  "fCountUp": "تصاعدي منذ الموعد",
  "fDesc": "الوصف",
  "fDescPh": "الوصف (اختياري)",
  "fDoneText": "عند حلول الموعد، اعرض",
  "fDoneTextPh": "مثال: نحن مفتوحون!",
  "fEnd": "النهاية",
  "fEveryHour": "كل ساعة | كل {n} ساعات",
  "fEveryMin": "كل {n} دقيقة",
  "fFoundPlaylist": "تم العثور على قائمة التشغيل.",
  "fFoundVideo": "تم العثور على الفيديو.",
  "fHeadline": "العنوان",
  "fInteractive": "السماح باللمس (شاشة تفاعلية)",
  "fItem": "العنصر",
  "fItemPh": "العنصر",
  "fLoop": "تكرار",
  "fMenuTitlePh": "مثال: قائمة اليوم",
  "fMessages": "الرسائل",
  "fMessagesHint": "رسالة واحدة في كل سطر.",
  "fMessagesPh": "مرحبًا بكم في متجرنا\nواي فاي مجاني: Guest",
  "fMuted": "كتم الصوت",
  "fNever": "أبدًا",
  "fPrice": "السعر",
  "fPricePh": "السعر",
  "fQrData": "رابط أو نص",
  "fRefresh": "إعادة تحميل الصفحة",
  "fRemove": "إزالة",
  "fSection": "القسم",
  "fSectionPh": "اسم القسم (مثال: مشروبات ساخنة)",
  "fSeparator": "بين الرسائل",
  "fShowDate": "عرض التاريخ",
  "fSlideSeconds": "ثوانٍ لكل شريحة",
  "fSlidesHint": "في Google Slides اختر ملف ← مشاركة ← النشر على الويب، أو اجعل الرابط متاحًا \"لأي شخص لديه الرابط\".",
  "fSlidesLink": "رابط Google Slides",
  "fStart": "البداية",
  "fTarget": "التاريخ والوقت",
  "fTitle": "العنوان",
  "fUrl": "عنوان الموقع",
  "fUrlHint": "بعض المواقع لا تسمح بعرضها داخل تطبيق آخر؛ تبقى فارغة. يحتاج المشغل إلى الإنترنت لهذا التطبيق.",
  "fXLarge": "كبير جدًا",
  "fYouTubeHint": "يحتاج المشغل إلى الإنترنت. يُسمع الصوت فقط عند إلغاء الكتم ورفع صوت المشغل.",
  "fYouTubeLink": "رابط يوتيوب",
  "fZoom": "التكبير",
  "time": "الوقت",
  "timeDesc": "ساعة دائرية أو رقمية مع التاريخ، بالعربية أو الإنجليزية.",
  "prayer_time": "أوقات الصلاة",
  "prayer_timeDesc": "أوقات الصلاة اليومية، تُحسب على المشغل.",
  "weather": "الطقس",
  "weatherDesc": "الحالة الحالية والتوقعات لموقع ما.",
  "rss": "خلاصات RSS",
  "rssDesc": "عناوين متحركة من أي خلاصة RSS أو Atom عبر https.",
  "fHex": "{what} (ست عشري)",
  "pvAt": "معاينة في {place}، والأوقات بتوقيت {zone} (يستخدم كل مشغل منطقته الزمنية).",
  "method_GULF": "منطقة الخليج",
  "method_MAKKAH": "أم القرى، مكة المكرمة",
  "method_MWL": "رابطة العالم الإسلامي",
  "method_EGYPT": "الهيئة المصرية العامة للمساحة",
  "method_KARACHI": "جامعة العلوم الإسلامية، كراتشي",
  "method_ISNA": "الجمعية الإسلامية لأمريكا الشمالية",
  "method_SINGAPORE": "سنغافورة",
  "method_TEHRAN": "معهد الجيوفيزياء، طهران",
  "method_JAFARI": "الشيعة الاثنا عشرية (الجعفري)",
  "fArabic": "العربية",
  "fEnglish": "الإنجليزية",
  "fUrdu": "الأردية",
  "fAppLanguage": "لغة التطبيق",
  "fTimeFormat": "تنسيق الوقت",
  "f24": "٢٤ ساعة",
  "fAmPm": "ص/م",
  "fTimezone": "المنطقة الزمنية",
  "fPlayerLocation": "موقع المشغل",
  "fCustom": "مخصص",
  "fCustomTz": "منطقة زمنية مخصصة",
  "fClockType": "نوع الساعة",
  "fRound": "ساعة دائرية",
  "fDigital": "ساعة رقمية",
  "fMore": "خيارات إضافية",
  "fHideCity": "إخفاء المدينة/الدولة",
  "fHideDate": "إخفاء التاريخ",
  "fShowSeconds": "إظهار الثواني",
  "fHideSeconds": "إخفاء الثواني",
  "fHideTime": "إخفاء الوقت أسفل الساعة",
  "fHideSecondsHand": "إخفاء الثواني (وعقرب الثواني)",
  "fMethod": "طريقة الحساب",
  "fAsr": "العصر",
  "fStandard": "الجمهور (الشافعي، المالكي، الحنبلي)",
  "fHanafi": "الحنفي",
  "fHighlight": "تمييز الصلاة التالية",
  "fTemperature": "درجة الحرارة",
  "fCelsius": "مئوية",
  "fFahrenheit": "فهرنهايت",
  "fForecast": "أيام التوقعات",
  "fNone": "بلا",
  "fLocation": "الموقع",
  "fOwnCoords": "يستخدم كل مشغل إحداثياته الخاصة (المضبوطة في المشغلات ← تعديل).",
  "fLatPh": "خط العرض، مثل 25.2048",
  "fLat": "خط العرض",
  "fLngPh": "خط الطول، مثل 55.2708",
  "fLng": "خط الطول",
  "fRssUrl": "رابط RSS",
  "fFontSize": "حجم خط التطبيق",
  "fSmall": "صغير",
  "fMedium": "متوسط",
  "fLarge": "كبير",
  "fSpeed": "السرعة",
  "fSlow": "بطيء",
  "fFast": "سريع",
  "fDirection": "اتجاه النص",
  "fLtr": "من اليسار إلى اليمين",
  "fRtl": "من اليمين إلى اليسار",
  "fHeadlines": "العناوين",
  "fBg": "لون الخلفية",
  "fFg": "لون الخط",
  "pvOf": "معاينة التطبيق",
  "pvEnterFeed": "أدخل رابط مصدر https لمعاينة عناوينه.",
  "pvApprox": "معاينة تقريبية؛ يعرض المشغل هذا التطبيق بشكل أصلي.",
  "pvLoading": "جارٍ تحميل العناوين…",
  /* Meeting room */
  "meeting_room": "غرفة الاجتماعات",
  "meeting_roomDesc": "شاشة على باب الغرفة: متاحة أو مشغولة الآن، والاجتماع الحالي والتالي وبقية اليوم، من رابط تقويم الغرفة.",
  "mrIcalLink": "رابط تقويم الغرفة (iCal)",
  "mrRoomName": "اسم الغرفة",
  "mrRoomNamePh": "فارغ: اسم التقويم نفسه",
  "mrHideTitles": "إخفاء عناوين الاجتماعات (عرض «مشغولة» فقط)",
  "mrShowOrganizer": "عرض المنظّم",
  "mrMaxUpcoming": "عدد الاجتماعات اللاحقة المعروضة",
  "mrLayout": "التخطيط",
  "mrAuto": "تلقائي",
  "mrLandscape": "أفقي",
  "mrPortrait": "عمودي",
  "mrFreeColor": "لون «متاحة»",
  "mrBusyColor": "لون «مشغولة»",
  "mrNoMeeting": "لا يوجد اجتماع الآن",
  "stream": "بث الفيديو",
  "streamDesc": "بث مباشر (HLS ‎.m3u8 أو MPEG-DASH ‎.mpd) أو ملف فيديو يُشغَّل من رابطه.",
  "stLink": "رابط البث (https)",
  "stCheck": "تحقق من الرابط",
  "stChecking": "جارٍ التحقق…",
  "stBadLink": "أدخل رابط https:// كاملًا للبث (مثل https://example.com/live/index.m3u8).",
  "stOk": "الرابط يستجيب: {kind}. تعرضه المعاينة.",
  "stKind_hls": "بث HLS",
  "stKind_dash": "بث MPEG-DASH",
  "stKind_file": "ملف فيديو",
  "stKind_unknown": "بث",
  "stVerdict_ok": "الرابط يستجيب.",
  "stVerdict_not_stream": "هذا الرابط يفتح صفحة ويب أو محتوى آخر وليس بث فيديو. استخدم رابط ‎.m3u8 أو ‎.mpd الخاص بالبث.",
  "stVerdict_login": "البث يتطلب تسجيل الدخول، ولا يمكن للشاشات تسجيل الدخول. استخدم رابطًا عامًا.",
  "stVerdict_not_found": "لا يوجد شيء على هذا الرابط. ربما انتهى البث أو نُقل.",
  "stVerdict_error": "تعذر الوصول إلى البث الآن.",
  "stEnterLink": "أدخل رابط البث لمعاينته.",
  "stSupported": "المدعوم: HLS ‏(.m3u8) وMPEG-DASH ‏(.mpd) وملفات الفيديو (.mp4 و.webm) عبر https. غير مدعوم: RTSP وRTMP وYouTube وصفحات الويب الأخرى (استخدم تطبيق YouTube أو صفحة الويب) والبث المحمي بـ DRM.",
  "stOnline": "البث المباشر يحتاج إلى الإنترنت: الشاشات غير المتصلة تعرض الصورة / النص أدناه وتعيد الاتصال تلقائيًا عند عودة الشبكة.",
  "stFit": "الملاءمة",
  "stContain": "الصورة كاملة",
  "stCover": "ملء المنطقة",
  "stMuted": "كتم الصوت",
  "stPoster": "رابط صورة الغلاف (اختياري)",
  "stFallback": "نص أثناء الاتصال أو عند توقف البث (اختياري)",
  "stFallbackHint": "يظهر على لون الخلفية، مع صورة الغلاف إن وُجدت.",
  // Social wall app
  "social_wall": "جدار التواصل الاجتماعي",
  "social_wallDesc": "منشورات التواصل الاجتماعي كبطاقات (الكاتب، الصورة، الوقت، المنصة) من مصدر بيانات: Google Sheet أو موجز RSS/Atom مثل حساب Mastodon.",
  "swPickFeed": "اختر مصدر بيانات فيه منشوراتك",
  "swFeedHint": "صف لكل منشور. موجزات RSS وAtom (حسابات Mastodon وجسور RSS) تعمل كما هي؛ الصور روابط https.",
  "swNoFeeds": "لا توجد مصادر بيانات بعد: أنشئ واحدًا من Google Sheet (الكاتب، المعرف، الصورة الشخصية، النص، الصورة، التاريخ، المنصة) أو من موجز RSS.",
  "swWall": "جدار",
  "swSpotlight": "منشور واحد في كل مرة",
  "swStrip": "شريط متحرك",
  "swText": "نص المنشور من",
  "swAuthor": "الكاتب من",
  "swHandle": "المعرف من",
  "swAvatar": "الصورة الشخصية من",
  "swImage": "الصورة من",
  "swDate": "التاريخ من",
  "swPlatform": "المنصة من",
  "swMax": "أقصى عدد للمنشورات",
  "swPageSeconds": "ثوانٍ لكل صفحة",
  "swPostSeconds": "ثوانٍ لكل منشور",
  "swCardSeconds": "ثوانٍ لكل بطاقة",
  "swImagesOnly": "المنشورات التي فيها صورة فقط",
  "swShowPlatform": "إظهار شارة المنصة",
  "swNoPosts": "لا توجد منشورات في هذا المصدر بعد",
};
export default { en, ar };
